import { createSlice } from '@reduxjs/toolkit';
import request from '../../service';
import Exported from '../../service/endpoints';
import config from '../../service/env';

const ccSlice = createSlice({
  name: 'ccData',
  initialState: {
    mapbox: {
      isDraw: true,
    },
  },
  reducers: {
    setMapBoxData: (state, action) => {
      console.log('first', {
        ...state.mapbox,
        ...action.payload,
      });
      state.mapbox = {
        ...state.mapbox,
        ...action.payload,
      };
    },
  },
});

export const { setMapBoxData } = ccSlice.actions;

export { ccSlice };

export const CCgetTrainingList = (data) => {
  const queryString =
    data && Object.keys(data)?.length ? `?${new URLSearchParams(data).toString()}` : '';
  return request({
    url: Exported.Endpoints.CCtrainingModule + queryString,
    method: Exported.APIMethods.GET,
    data,
    baseUrl: config.complianceServiceApi,
  });
};

export const CCgetTrainingByID = (id) => {
  return request({
    url: `${Exported.Endpoints.CCtrainingModule}/${id}`,
    method: Exported.APIMethods.GET,
    baseUrl: config.complianceServiceApi,
  });
};

export const CCUpdateFarmCoordinates = (data, id) => {
  return request({
    url: Exported.Endpoints.verifyFarmerFarm + `?id=${id}`,
    method: Exported.APIMethods.POST,
    data,
    baseUrl: config.complianceServiceApi,
  });
};

const postCCTrainingModule = (data) => {
  return request({
    url: Exported.Endpoints.CCtrainingModule,
    method: Exported.APIMethods.POST,
    data,
    baseUrl: config.complianceServiceApi,
  });
};

export const CCcreateTrainingModule = (data) => {
  return postCCTrainingModule(data);
};

export const CCupdateTrainingModule = (data, id) => {
  return request({
    url: `${Exported.Endpoints.CCtrainingModule}/${id}`,
    method: Exported.APIMethods.PATCH,
    data,
    baseUrl: config.complianceServiceApi,
  });
};

export const CCdeleteTrainingModule = (data) => {
  return request({
    url: `${Exported.Endpoints.CCtrainingModule}/${data?.id}`,
    method: Exported.APIMethods.DELETE,
    data,
    baseUrl: config.complianceServiceApi,
  });
};

export const CCcreateLessonModule = (data) => {
  return request({
    url: Exported.Endpoints.CClessonModule,
    method: Exported.APIMethods.POST,
    data,
    baseUrl: config.complianceServiceApi,
  });
};

export const CCupdateLessonModule = (data) => {
  return request({
    url: `${Exported.Endpoints.CClessonModule}/${data?.id}`,
    method: Exported.APIMethods.PATCH,
    data,
    baseUrl: config.complianceServiceApi,
  });
};

export const CCgetLessonModule = (data) => {
  return request({
    url: Exported.Endpoints.createEventCC + queryString,
    method: Exported.APIMethods.GET,
    data,
    baseUrl: config.complianceServiceApi,
  });
};

export const createCCEventSubmit = (data) => {
  return request({
    url: Exported.Endpoints.createEventCC,
    method: Exported.APIMethods.POST,
    data,
    baseUrl: config.complianceServiceApi,
  });
};

export const getCCEventsList = (data) => {
  const queryString =
    data && Object.keys(data)?.length ? `?${new URLSearchParams(data).toString()}` : '';
  return request({
    url: Exported.Endpoints.createEventCC + queryString,
    method: Exported.APIMethods.GET,
    data,
    baseUrl: config.complianceServiceApi,
  });
};

export const CCgetLessonByID = (data, id) => {
  const queryString =
    data && Object.keys(data)?.length ? `?${new URLSearchParams(data).toString()}` : '';
  return request({
    url: `${Exported.Endpoints.CClessonModule}/${id}${queryString}`,
    method: Exported.APIMethods.GET,
    baseUrl: config.complianceServiceApi,
  });
};

export const CCdeleteLessonModule = (data) => {
  return request({
    url: `${Exported.Endpoints.CClessonModule}/${data?.id}`,
    method: Exported.APIMethods.DELETE,
    data,
    baseUrl: config.complianceServiceApi,
  });
};

export const CCgetLessonListByID = (id, data) => {
  const queryString =
    data && Object.keys(data)?.length ? `?${new URLSearchParams(data).toString()}` : '';
  return request({
    url: Exported.Endpoints.CCgetLessonsByID + id + queryString,
    method: Exported.APIMethods.GET,
    baseUrl: config.complianceServiceApi,
  });
};

export const CCupdateLessonCompletionStatus = (data) => {
  return postCCTrainingModule(data);
};

export const getCCEventByDate = (data) => {
  const queryString =
    data && Object.keys(data)?.length ? `?${new URLSearchParams(data).toString()}` : '';
  return request({
    url: Exported.Endpoints.eventByDateCC + queryString,
    method: Exported.APIMethods.GET,
    data,
    baseUrl: config.complianceServiceApi,
  });
};

export const getCalendarEventListCC = (data) => {
  const queryString =
    data && Object.keys(data)?.length ? `?${new URLSearchParams(data).toString()}` : '';
  return request({
    url: Exported.Endpoints.eventByDateFilterCC + queryString,
    method: Exported.APIMethods.GET,
    data,
    baseUrl: config.complianceServiceApi,
  });
};

export const getCCEventsParticipants = (data) => {
  const queryString =
    data && Object.keys(data)?.length ? `?${new URLSearchParams(data).toString()}` : '';
  return request({
    url: Exported.Endpoints.getCCParticipants + queryString,
    method: Exported.APIMethods.GET,
    data,
    baseUrl: config.complianceServiceApi,
  });
};

export const getInviteParticipantCC = (data) => {
  const queryString =
    data && Object.keys(data)?.length ? `?${new URLSearchParams(data).toString()}` : '';
  return request({
    url: Exported.Endpoints.inviteCCevent + queryString,
    method: Exported.APIMethods.GET,
    data,
    baseUrl: config.complianceServiceApi,
  });
};

export const getCCEventByID = (id) => {
  return request({
    url: `${Exported.Endpoints.createEventCC}/${id}`,
    method: Exported.APIMethods.GET,
    baseUrl: config.complianceServiceApi,
  });
};

export const patchCCEventByID = (id, data) => {
  return request({
    url: `${Exported.Endpoints.createEventCC}/${id}`,
    method: Exported.APIMethods.PATCH,
    data,
    baseUrl: config.complianceServiceApi,
  });
};

export const postCCInviteParticipant = (data) => {
  return request({
    url: Exported.Endpoints.postCCInvite,
    method: Exported.APIMethods.POST,
    data,
    baseUrl: config.complianceServiceApi,
  });
};
export const CCgetISHPotential = (queryParams) => {
  const queryString =
    queryParams && Object.keys(queryParams).length
      ? `?${new URLSearchParams(queryParams).toString()}`
      : '';

  return request({
    url: Exported.Endpoints.getISHPotential + queryString,
    method: Exported.APIMethods.GET,
    baseUrl: config.complianceServiceApi,
  });
};

export const CCgetESignsById = (id) => {
  return request({
    url: `${Exported.Endpoints.getFarmers}/${id}/esigns`,
    method: Exported.APIMethods.GET,
    baseUrl: config.complianceServiceApi,
  });
};

export const CCUploadEsign = (id, data) => {
  return request({
    url: `${Exported.Endpoints.getFarmers}/${id}/upload-multiple-esigns`,
    method: Exported.APIMethods.POST,
    data,
    baseUrl: config.complianceServiceApi,
  });
};

export const CCupdateEsignStatus = (id, data) => {
  return request({
    url: `${Exported.Endpoints.getESignsById}/${id}/documentapproval-status`,
    method: Exported.APIMethods.PATCH,
    data,
    baseUrl: config.complianceServiceApi,
  });
};

export const getVerificationData = (data) => {
  const queryString =
    data && Object.keys(data)?.length ? `?${new URLSearchParams(data).toString()}` : '';
  return request({
    url: Exported.Endpoints.getVerificationData + queryString,
    method: Exported.APIMethods.GET,
    data,
    baseUrl: config.complianceServiceApi,
  });
};

export const getAuditGroupData = (data) => {
  const queryString =
    data && Object.keys(data)?.length ? `?${new URLSearchParams(data).toString()}` : '';
  return request({
    url: Exported.Endpoints.getAuditGroupData + queryString,
    method: Exported.APIMethods.GET,
    data,
    baseUrl: config.complianceServiceApi,
  });
};

export const getAuditParticipantData = (data, groupId) => {
  const queryString =
    data && Object.keys(data)?.length ? `?${new URLSearchParams(data).toString()}` : '';
  return request({
    url: `${Exported.Endpoints.getAuditParticipantData}${groupId}/participants${queryString}`,
    method: Exported.APIMethods.GET,
    data,
    baseUrl: config.complianceServiceApi,
  });
};

export const saveAuditData = (data) => {
  return request({
    url: Exported.Endpoints.saveAuditData,
    method: Exported.APIMethods.POST,
    data,
    baseUrl: config.complianceServiceApi,
  });
};

export const updateAuditStatus = (groupId, data) => {
  return request({
    url: `${Exported.Endpoints.getAuditData}${groupId}`,
    method: Exported.APIMethods.PUT,
    data,
    baseUrl: config.complianceServiceApi,
  });
};

export const getAuditData = (groupId) => {
  return request({
    url: `${Exported.Endpoints.getAuditData}${groupId}`,
    method: Exported.APIMethods.GET,
    baseUrl: config.complianceServiceApi,
  });
};

export const exportInternalAudits = (groupId, data) => {
  const queryString =
    data && Object.keys(data)?.length ? `?${new URLSearchParams(data).toString()}` : '';
  return request({
    url: `${Exported.Endpoints.exportInternalAudits}${groupId}${queryString}`,
    method: Exported.APIMethods.GET,
    responseType: 'blob',
    baseUrl: config.complianceServiceApi,
    sendRes: true,
  });
};

export const postFarmerVerificationApproval = (data) => {
  return request({
    url: Exported.Endpoints.ccFarmerApproval,
    method: Exported.APIMethods.PUT,
    data,
    baseUrl: config.complianceServiceApi,
  });
};

export const markFarmerAuditStatus = (data) => {
  return request({
    url: Exported.Endpoints.markFarmerAuditStatus,
    method: Exported.APIMethods.POST,
    data,
    baseUrl: config.complianceServiceApi,
  });
};

export const CCApprovalRegisterList = (data) => {
  const queryString =
    data && Object.keys(data)?.length ? `?${new URLSearchParams(data).toString()}` : '';
  return request({
    url: Exported.Endpoints.CCApprovallist + queryString,
    method: Exported.APIMethods.GET,
    data,
    baseUrl: config.complianceServiceApi,
  });
};

export const CCAuditReviewList = (data) => {
  const queryString =
    data && Object.keys(data)?.length ? `?${new URLSearchParams(data).toString()}` : '';
  return request({
    url: Exported.Endpoints.CCAuditReviewList + queryString,
    method: Exported.APIMethods.GET,
    data,
    baseUrl: config.complianceServiceApi,
  });
};

export const CCAuditCompletionList = (data) => {
  const queryString =
    data && Object.keys(data)?.length ? `?${new URLSearchParams(data).toString()}` : '';
  return request({
    url: Exported.Endpoints.CCAuditCompletionList + queryString,
    method: Exported.APIMethods.GET,
    data,
    baseUrl: config.complianceServiceApi,
  });
};

export const CCApprovalTrainingList = (data) => {
  const queryString =
    data && Object.keys(data)?.length ? `?${new URLSearchParams(data).toString()}` : ' ';
  return request({
    url: Exported.Endpoints.CCAprovallistTraining + queryString,
    method: Exported.APIMethods.GET,
    data,
    baseUrl: config.complianceServiceApi,
  });
};

export const postParticipantRegisterApproval = (data) => {
  return request({
    url: Exported.Endpoints.CCApprovalRegisterApprove,
    method: Exported.APIMethods.POST,
    data,
    baseUrl: config.complianceServiceApi,
  });
};

export const postParticipantAuditReviewApproval = (data) => {
  return request({
    url: Exported.Endpoints.ccAuditReviewApproval,
    method: Exported.APIMethods.POST,
    data,
    baseUrl: config.complianceServiceApi,
  });
};

export const postParticipantAuditCompletionApproval = (data) => {
  return request({
    url: Exported.Endpoints.ccAuditCompletionApproval,
    method: Exported.APIMethods.POST,
    data,
    baseUrl: config.complianceServiceApi,
  });
};

export const postParticipantTrainingApproval = (data) => {
  return request({
    url: Exported.Endpoints.CCApprovalTrainingApprove,
    method: Exported.APIMethods.POST,
    data,
    baseUrl: config.complianceServiceApi,
  });
};

export const getCCAttendanceByEventId = (id, data) => {
  const queryString =
    data && Object.keys(data)?.length ? `?${new URLSearchParams(data).toString()}` : '';
  return request({
    url: Exported.Endpoints.attendanceByCCEventID + id + queryString,
    method: Exported.APIMethods.GET,
    baseUrl: config.complianceServiceApi,
  });
};

export const markCCAttendanceByparticipant = (data) => {
  return request({
    url: Exported.Endpoints.markCCAttendance,
    method: Exported.APIMethods.PUT,
    data,
    baseUrl: config.complianceServiceApi,
  });
};

//data collection

export const getCCParticipantById = (id) => {
  return request({
    url: Exported.Endpoints.ccFarmerParticipantById + id,
    method: Exported.APIMethods.GET,
    baseUrl: config.complianceServiceApi,
  });
};

export const getDataCollectionCC = (data) => {
  const queryString =
    data && Object.keys(data)?.length ? `?${new URLSearchParams(data).toString()}` : '';
  return request({
    url: Exported.Endpoints.getAllDataCollection + queryString,
    method: Exported.APIMethods.GET,
    data,
    baseUrl: config.complianceServiceApi,
  });
};

export const getCCDataCollectionFertilizer = (id) => {
  return request({
    url: Exported.Endpoints.getDataCollectionFertilizer + id,
    method: Exported.APIMethods.GET,
    baseUrl: config.complianceServiceApi,
  });
};

export const postDataCollectionFertilizer = (data) => {
  return request({
    url: Exported.Endpoints.postDataCollectionFertilizer,
    method: Exported.APIMethods.POST,
    data,
    baseUrl: config.complianceServiceApi,
  });
};

export const getCCDataCollectionChemical = (id) => {
  return request({
    url: Exported.Endpoints.getDataCollectionChemical + id,
    method: Exported.APIMethods.GET,
    baseUrl: config.complianceServiceApi,
  });
};

export const postDataCollectionChemical = (data) => {
  return request({
    url: Exported.Endpoints.postDataCollectionChemical,
    method: Exported.APIMethods.POST,
    data,
    baseUrl: config.complianceServiceApi,
  });
};

export const getCCDataCollectionFFBDetails = (id) => {
  return request({
    url: Exported.Endpoints.getCCFFBDetails + id,
    method: Exported.APIMethods.GET,
    baseUrl: config.complianceServiceApi,
  });
};

export const postDataCollectionFFBDetails = (data) => {
  return request({
    url: Exported.Endpoints.postCCFFBDetails,
    method: Exported.APIMethods.POST,
    data,
    baseUrl: config.complianceServiceApi,
  });
};

export const getCCDataCollectionExpenses = (id) => {
  return request({
    url: Exported.Endpoints.getCCExpenses + id,
    method: Exported.APIMethods.GET,
    baseUrl: config.complianceServiceApi,
  });
};
export const postCCDataCollectionExpenses = (data) => {
  return request({
    url: Exported.Endpoints.postCCExpenses,
    method: Exported.APIMethods.POST,
    data,
    baseUrl: config.complianceServiceApi,
  });
};
export const postCCDataCollectionFarmDetails = (id, data) => {
  return request({
    url: `${Exported.Endpoints.postCCFarm}/${id}`,
    method: Exported.APIMethods.POST,
    data,
    baseUrl: config.complianceServiceApi,
  });
};
export const getCCDataCollectionFarmerDetails = (id) => {
  return request({
    url: Exported.Endpoints.getCCFarmerDetails + id,
    method: Exported.APIMethods.GET,
    baseUrl: config.complianceServiceApi,
  });
};

export const postCCDataCollectionFarmerDetails = (data) => {
  return request({
    url: Exported.Endpoints.postCCFarmerDetails,
    method: Exported.APIMethods.POST,
    data,
    baseUrl: config.complianceServiceApi,
  });
};

export const getCCDataCollectionFarmDetails = (id) => {
  return request({
    url: Exported.Endpoints.getCCFarm + id,
    method: Exported.APIMethods.GET,
    baseUrl: config.complianceServiceApi,
  });
};

export const getCCDataSpocAreas = (data) => {
  const queryString = Object.keys(data).length ? `?${new URLSearchParams(data).toString()}` : '';
  return request({
    url: Exported.Endpoints.getCCSpocAreas + queryString,
    method: Exported.APIMethods.GET,
    data,
    baseUrl: config.complianceServiceApi,
  });
};

export const getCCDataRissGroups = () => {
  return request({
    url: Exported.Endpoints.getCCRissGroups,
    method: Exported.APIMethods.GET,
    baseUrl: config.complianceServiceApi,
  });
};

export const getDataCollectionById = (id) => {
  return request({
    url: Exported.Endpoints.getDataCollectionById + id,
    method: Exported.APIMethods.GET,
    baseUrl: config.complianceServiceApi,
  });
};

export const postDataCollectionById = (id, data) => {
  return request({
    url: Exported.Endpoints.postDataCollectionbyid + id,
    method: Exported.APIMethods.POST,
    data,
    baseUrl: config.complianceServiceApi,
  });
};

export const putDataCollectionApprovalByAll = (data) => {
  return request({
    url: Exported.Endpoints.putDataCollectionApproval,
    method: Exported.APIMethods.PUT,
    data,
    baseUrl: config.complianceServiceApi,
  });
};

//data collection - Data
export const getDetailsOfDatainDataCollection = (data) => {
  const queryString =
    data && Object.keys(data)?.length ? `?${new URLSearchParams(data).toString()}` : '';
  return request({
    url: Exported.Endpoints.getDetailsOfDatainDataCollection + queryString,
    method: Exported.APIMethods.GET,
    baseUrl: config.complianceServiceApi,
  });
};

export const getFarmsListOfFarmer = (data) => {
  const queryString =
    data && Object.keys(data)?.length ? `?${new URLSearchParams(data).toString()}` : '';
  return request({
    url: Exported.Endpoints.getFarmsListOfFarmer + queryString,
    method: Exported.APIMethods.GET,
    baseUrl: config.complianceServiceApi,
  });
};
//worker DataCollection
export const getCCDataCollectionWorker = (id) => {
  return request({
    url: Exported.Endpoints.getWorkedDataBasedonFarm + id,
    method: Exported.APIMethods.GET,
    baseUrl: config.complianceServiceApi,
  });
};

export const postCCDataCollectionWorker = (data) => {
  return request({
    url: Exported.Endpoints.postWorkedDataBasedonFarm,
    method: Exported.APIMethods.POST,
    data,
    baseUrl: config.complianceServiceApi,
  });
};

//data collection

export const getCCDataCollectionOwner = (id) => {
  return request({
    url: Exported.Endpoints.getCCOwnerDetails + id,
    method: Exported.APIMethods.GET,
    id,
    baseUrl: config.complianceServiceApi,
  });
};

export const postCCDataCollectionOwner = (data) => {
  return request({
    url: Exported.Endpoints.postCCOwnerDetails,
    method: Exported.APIMethods.POST,
    data,
    baseUrl: config.complianceServiceApi,
  });
};

export const getCCFarmerJourney = (data) => {
  const queryString =
    data && Object.keys(data)?.length ? `?${new URLSearchParams(data).toString()}` : '';
  return request({
    url: Exported.Endpoints.ccFarmerJourney + queryString,
    method: Exported.APIMethods.GET,
    baseUrl: config.complianceServiceApi,
  });
};

export const getCCReports = (data) => {
  const queryString =
    data && Object.keys(data)?.length ? `?${new URLSearchParams(data).toString()}` : '';
  return request({
    url: Exported.Endpoints.reportsCC + queryString,
    method: Exported.APIMethods.GET,
    baseUrl: config.complianceServiceApi,
  });
};

export const patchCCPotentialByID = (id, data) => {
  return request({
    url: `${Exported.Endpoints.getFarmers}/${id}/http-verification-status`,
    method: Exported.APIMethods.PATCH,
    data,
    baseUrl: config.complianceServiceApi,
  });
};

export const getExportCCFarmerJourney = (data) => {
  return request({
    url: Exported.Endpoints.exportCCFarmerJourney,
    method: Exported.APIMethods.POST,
    data,
    responseType: 'blob',
    baseUrl: config.complianceServiceApi,
    sendRes: true,
  });
};

export const getAnalyticsforCC = (data) => {
  const queryString = Object.keys(data).length ? `?${new URLSearchParams(data).toString()}` : '';
  return request({
    url: Exported.Endpoints.ccDashboard + queryString,
    method: Exported.APIMethods.GET,
    data,
    baseUrl: config.complianceServiceApi,
  });
};

export const participantAnalytics = (data) => {
  const queryString = Object.keys(data).length ? `?${new URLSearchParams(data).toString()}` : '';
  return request({
    url: Exported.Endpoints.ccDashboardParticipant + queryString,
    method: Exported.APIMethods.GET,
    data,
    baseUrl: config.complianceServiceApi,
  });
};

//Notification List
export const getNotificationList = (data) => {
  const queryString =
    data && Object.keys(data)?.length ? `?${new URLSearchParams(data).toString()}` : '';
  return request({
    url: Exported.Endpoints.notificationList + queryString,
    method: Exported.APIMethods.GET,
    baseUrl: config.notificationServiceApi,
  });
};

//Mark all as read
export const markAllNotificationsAsRead = (data) => {
  return request({
    url: Exported.Endpoints.markAllAsRead,
    method: Exported.APIMethods.PATCH,
    data,
    baseUrl: config.notificationServiceApi,
  });
};

//Mark as read
export const markNotificationAsRead = (data) => {
  return request({
    url: `${Exported.Endpoints.markAsRead}`,
    method: Exported.APIMethods.PATCH,
    data,
    baseUrl: config.notificationServiceApi,
  });
};

//export cc farmer data
export const getCCAttendanceExportData = (data) => {
  return request({
    url: Exported.Endpoints.downloadReports,
    method: Exported.APIMethods.POST,
    data,
    responseType: 'blob',
    baseUrl: config.complianceServiceApi,
    sendRes: true,
  });
};

export const exportCCData = (data) => {
  const queryString =
    data && Object.keys(data)?.length ? `?${new URLSearchParams(data).toString()}` : '';
  return request({
    url: Exported.Endpoints.exportReportData + queryString,
    method: Exported.APIMethods.GET,
    baseUrl: config.complianceServiceApi,
  });
};
